import React, {createContext} from 'react';
import PropTypes from 'prop-types';
import useRouteResolver from '../hooks/useRouteResolver';
import {RouterHistoryContextProvider} from './RouterHistoryContext';

const Context = createContext({
  resourceId: '',
  isCategoryUrl: false,
  isFetching: false,
  redirectCode: '',
  relativeUrl: '',
});

export default Context;

export const RouteResolverContextProvider = ({children}) => {
  const {isFetching, data: routeResolver} = useRouteResolver();

  const {resourceId, redirectCode, relativeUrl, type} = routeResolver || {};

  return (
    <Context.Provider
      value={{
        resourceId,
        isCategoryUrl: type === 'CATEGORY',
        isFetching,
        redirectCode,
        relativeUrl,
      }}>
      <RouterHistoryContextProvider>{children}</RouterHistoryContextProvider>
    </Context.Provider>
  );
};

RouteResolverContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
